'use client';

import { Icon } from '@/general/Icons/Icon';
import { FC, useEffect, useState } from 'react';

import { CircularProgress } from '@/general/components/CircularProgress/CircularProgress';
import { getSha256Hash } from '@/general/helpers/getSha256Hash';
import { getUserInitials } from '@/general/helpers/getUserInitials';

interface Props {
  loading?: boolean;
  notification?: boolean;
  userData: { firstName: string; lastName: string; email: string } | null;
}

export const UserAvatar: FC<Props> = ({ loading, notification, userData }) => {
  const userInitials = getUserInitials(userData);
  const [emailSha, setEmailSha] = useState<string | null>(null);
  const authenticated = !!userData;

  useEffect(() => {
    let mounted = true;
    if (userData?.email) {
      getSha256Hash(userData.email.toLowerCase()).then((value) => {
        if (mounted) {
          setEmailSha(value);
        }
      });
    } else {
      setEmailSha(null);
    }

    return () => {
      mounted = false;
    };
  }, [userData?.email]);

  return (
    <div className="relative size-7 rounded-full border border-bor-pri-dis">
      {loading && (
        <span className="absolute -top-0.5 -left-0.5">
          <CircularProgress className="!text-[30px]" />
        </span>
      )}
      <div className="absolute top-0 left-0 flex size-full items-center justify-center overflow-hidden rounded-full bg-bac-tie1 text-tex-def-tie1">
        {authenticated ? (
          <>
            <span className="c-fs-caption2 font-extrabold">{userInitials}</span>
            {!!emailSha && (
              <img
                src={`https://gravatar.com/avatar/${emailSha}?d=blank`}
                alt=""
                loading="lazy"
                width={80}
                height={80}
                className="absolute top-0 left-0 size-full"
              />
            )}
          </>
        ) : (
          <Icon name="avatar" />
        )}
      </div>
      {notification && <div className="absolute -top-px -right-px size-2 rounded-full bg-for-pri-acc" />}
    </div>
  );
};
